<template>
  <div class="vod-stats">
    <div class="vod-stats__header">
      <div>
        <h2>다시보기 통계</h2>
        <p>계정별 다시보기 로그인 횟수와 누적 시청 시간입니다.</p>
      </div>
      <div class="vod-stats__actions">
        <div class="vod-stats__search">
          <v-icon>mdi-magnify</v-icon>
          <input v-model="searchQuery" placeholder="이름 또는 이메일 검색" />
        </div>
        <v-btn icon :loading="loading" @click="reload">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="downloadExcel">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>다시보기 통계 다운로드</span>
        </v-tooltip>
      </div>
    </div>

    <v-data-table
      item-key="user_id"
      :headers="headers"
      :items="filteredItems"
      :items-per-page="10"
      :loading="loading"
      class="data-table"
    >
      <template v-slot:item.total_watched_seconds="{ item }">
        {{ formatDuration(item.total_watched_seconds) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    reload: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
      headers: [
        { text: '이름', value: 'username' },
        { text: '이메일', value: 'email' },
        { text: '로그인 횟수', value: 'login_count', align: 'end' },
        { text: '총 누적 시청 시간', value: 'total_watched_seconds', align: 'end' },
        { text: '최근 다시보기 로그인', value: 'last_vod_login' },
        { text: '최근 시청 기록', value: 'last_watched_at' },
      ],
    };
  },
  computed: {
    filteredItems() {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) return this.items;
      return this.items.filter((item) => {
        const name = String(item.username || '').toLowerCase();
        const email = String(item.email || '').toLowerCase();
        return name.includes(query) || email.includes(query);
      });
    },
  },
  methods: {
    formatDuration(seconds) {
      const total = Math.max(0, Number(seconds) || 0);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const secs = Math.floor(total % 60);
      return [hours, minutes, secs].map((value) => String(value).padStart(2, '0')).join(':');
    },
    downloadExcel() {
      const rows = this.items.map((item) => ({
        이름: item.username,
        이메일: item.email,
        '다시보기 로그인 횟수': Number(item.login_count) || 0,
        '총 누적 시청 시간': this.formatDuration(item.total_watched_seconds),
        '최근 다시보기 로그인': item.last_vod_login || '',
        '최근 시청 기록': item.last_watched_at || '',
      }));
      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet['!cols'] = [
        { wch: 12 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
        { wch: 22 },
        { wch: 22 },
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '다시보기통계');
      const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'vod_watch_stats.xlsx');
    },
  },
};
</script>

<style scoped>
.vod-stats__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.vod-stats__header h2,
.vod-stats__header p {
  margin: 0;
}

.vod-stats__header p {
  margin-top: 5px;
  color: #747b89;
  font-size: 13px;
}

.vod-stats__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.vod-stats__search {
  display: flex;
  align-items: center;
  width: 300px;
  padding: 7px 11px;
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  background: #fff;
}

.vod-stats__search input {
  width: 100%;
  margin-left: 6px;
  outline: none;
}

@media (max-width: 760px) {
  .vod-stats__header {
    display: block;
  }

  .vod-stats__actions {
    margin-top: 14px;
  }

  .vod-stats__search {
    width: 100%;
  }
}
</style>
